import PropTypes from 'prop-types';
import { getPartName } from '@app/utils/commonUtils';
import { useSelector } from 'react-redux';
import { PCC_HEADLESS_PDP_FLAG } from '@app/constants/featureFlags';

const NameCell = ({ item }) => {
  const { productURL, name, partNumber } = item;
  const esiteURL = useSelector(s => s.common?.esiteURL);
  const isPDPHeadlessFeatureFlagEnable =
    useSelector(s => s.featureFlag?.[PCC_HEADLESS_PDP_FLAG]) ?? false;

  const urlBasedonFeatureFlag = isPDPHeadlessFeatureFlagEnable
    ? `${esiteURL}/product/${partNumber}`
    : productURL;

  return (
    <a className="u-fs--16 text-univers" href={urlBasedonFeatureFlag}>
      {getPartName(partNumber, name)}
    </a>
  );
};

NameCell.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    productURL: PropTypes.string,
    partNumber: PropTypes.string
  })
};

export default NameCell;
